import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-fees-management',
  templateUrl: './fees-management.component.html',
  styleUrls: ['./fees-management.component.css']
})
export class FeesManagementComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
